import React from 'react'
import { RWebShare } from "react-web-share";
import ShareIcon from '@material-ui/icons/Share';
export default function Share({text,url,title,item,type,id,image,resume}) {


  const share=async ()=>{
	  
	  console.log(type,id,url);
    try{
      await window.navigator.share({text,url,title});
    }catch(err){
      console.log("error",err)
    }
    
  }
  
  
  
  const sanitize=(str)=>{
	  if(str==null) return "";
	  let new_str="";
	  new_str=str?.replace(/\s/g,"%20");
	  new_str=new_str.replace(/'/g,"`");
	  new_str=new_str.replace(/\?/g,"!");
	  new_str=new_str.replace(/#/g,"$");
	  return new_str;
  }
  
  let new_titre=sanitize(title);
  let new_resume=sanitize(resume);
  
  const new_url=`https://ongadesco.org/partage2.php?id=${id}`
  return (

    <div className="items-center justify-center flex absolute bottom-0 right-0">

        {/*<button
          onClick={share}
            className="p-1 mb-2 w-32 text-red-800 rounded-none text-xs font-bold"
            >Partager <ShareIcon />
        </button>*/}
        <RWebShare
            data={{text,url:new_url,title}}
            onClick={() => console.log("shared successfully!")}
        >
            <button
            className="p-1 mb-2 w-32 text-red-800 rounded-none text-xs font-bold"
            >Partager <ShareIcon /></button>
        </RWebShare>
    </div>
  )
}
